import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { ModalTemplateComponent } from './modal-template.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [ModalTemplateComponent],
  imports: [CommonModule, SvgIconModule, A11yModule],
  exports: [ModalTemplateComponent],
})
export class ModalTemplateModule {}
